import { render, staticRenderFns } from "./toggle.vue?vue&type=template&id=22a7badf&scoped=true"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"
import style0 from "./toggle.vue?vue&type=style&index=0&id=22a7badf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7badf",
  null
  
)

export default component.exports